import window from 'window-or-global';
import { default as aeTable } from './aeTable';

export default () => {
	window.tinymce.create('tinymce.plugins.aeTable', aeTable());
	window.tinymce.PluginManager.add('aeTable', window.tinymce.plugins.aeTable);
};
